import React, { useEffect, useState } from "react";
import { Collapse, Typography } from "antd";
import "./mobilePaymentNavigation.css";
import { useDispatch, useSelector } from "react-redux";
import {
  changeActivePaymentMethod,
  selectActivePaymentMethod,
} from "../../../../slices/PaymentButtonSlice";
import { categorySelectedEvent } from "../../../../Utils/uiAnalytics";
import { handleTotalPaymentSummaryError } from "../../../../slices/HandleAdditionalComponentsSlice";
import TranslateText from "../../../resuableComponents/TranslateText";
import { removeSelectedIntruments } from "../../../../slices/SavedInstrumentSlice";
import { showRetryLimitReached } from "../../../../slices/PaymentInitiationSlice";

const { Panel } = Collapse;

const MobilePaymentNavigation = ({
  icon,
  tabType,
  title,
  subTitleStyling,
  children,
  collapseKey,
  whiteBackground,
  activeColor,
  destroyOnCollapse,
  extra,
  previewIcons,
  smallPreviewIcons,
}) => {
  const activePaymentMethod = useSelector(selectActivePaymentMethod);
  const methodAttemptsLeft = useSelector((state) => state.paymentInitiation.methodAttemptsLeft);
  const dispatch = useDispatch();
  const isActive = activePaymentMethod === collapseKey;

  const handlePaymentChange = (key) => {
    const latestSelectedKey = key.slice(-1)[0];
    // Attempts for this payment method are used up: show the error and keep the current method.
    if (methodAttemptsLeft[latestSelectedKey] === 0) {
      dispatch(showRetryLimitReached({ reasonCode: "BE_1815" }));
      return;
    }
    if (latestSelectedKey !== activePaymentMethod) {
      dispatch(removeSelectedIntruments());
    }
    dispatch(changeActivePaymentMethod(latestSelectedKey));
    categorySelectedEvent(latestSelectedKey);
    dispatch(handleTotalPaymentSummaryError(""));
  };

  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    setIsCollapsed(false);
  }, [activePaymentMethod]);

  const onChange = (key) => {
    if (Array.isArray(key) && key.length > 0) {
      setIsCollapsed(false);
      handlePaymentChange(key);
    } else if (isActive) {
      setIsCollapsed(true);
    }
  };

  return (
    <Collapse
      expandIconPosition="end"
      className={`payment-nav-root ${whiteBackground ? "payment-nav-white" : ""} ${isActive ? "payment-nav-active" : ""}`}
      activeKey={isCollapsed ? [] : activePaymentMethod}
      onChange={onChange}
      destroyInactivePanel={destroyOnCollapse}
      style={isActive && activeColor ? { boxShadow: `0px 0px 10px -4px ${activeColor}66` } : undefined}
    >
      <Panel
        header={
          <div className="po-nav-logo-title">
            {icon}
            <div className="po-nav-title-icons-wrap">
              <Typography
                className={
                  subTitleStyling
                    ? "po-nav-subtitle regular14Heading dynamic-font-family"
                    : "po-nav-title dynamic-font-family"
                }
              >
                <TranslateText label={tabType}>{title}</TranslateText>
              </Typography>
              {previewIcons?.length > 0 && (
                <div
                  className={`po-preview-icon-group${smallPreviewIcons ? " po-preview-icon-group-wide-gap" : ""}`}
                  style={{ marginLeft: "auto" }}
                >
                  {previewIcons.map((entry, iconIdx) => (
                    <img
                      key={entry?.id || iconIdx}
                      src={entry?.logoUrl || entry?.logo}
                      alt={entry?.title || entry?.name}
                      className={`po-preview-icon${smallPreviewIcons ? " po-preview-icon-small" : ""}`}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        }
        key={collapseKey}
        showArrow
        extra={extra}
      >
        {children && <div className="dynamic-font-family">{children}</div>}
      </Panel>
    </Collapse>
  );
};

export default MobilePaymentNavigation;
